(() => {
  function displayDimension(value) {
    // Nominal inch bases use the tabletop convention 25/50/75mm, not 25.4/50.8/76.2.
    // Keep exact source dimensions in metadata; this is storefront formatting only.
    const inches = Math.round(value / 25.4);
    return inches > 0 && Math.abs(value - inches * 25.4) < 0.05 ? inches * 25 : Math.round(value);
  }

  function labelFor(entry, labels, locale, isCard = false) {
    if (!entry) return '';
    if (entry.mode === 'without_base') return labels[2];
    const source = isCard ? entry.reference_dimensions_mm : (entry.dimensions_mm || entry.reference_dimensions_mm);
    if (entry.mode !== 'with_base' || !source?.length) return '';
    if (source.some(n => !Number.isFinite(n) || n <= 0)) return '';
    const format = new Intl.NumberFormat(locale || 'en', { maximumFractionDigits: 0 });
    const dimensions = source.map(n => format.format(displayDimension(n))).join(' × ');
    return isCard ? `${labels[8]} · ${dimensions}mm ${labels[6]}` : `${dimensions}mm ${labels[6]}`;
  }

  function cardEntryFor(entries, nativeId) {
    const entry = entries[String(nativeId)];
    if (entry?.mode !== 'without_base') return entry;
    // A card thumbnail selects an execution, not its base sales option.
    if (!entry.execution_id) return undefined;
    return Object.values(entries).find(sibling => sibling.execution_id === entry.execution_id &&
      sibling.mode === 'with_base' && sibling.reference_dimensions_mm?.length && sibling.reference_scale_mm > 0);
  }

  function entryFor(entries, nativeVariants, values) {
    const native = nativeVariants.find(v => v.options.length === values.length &&
      v.options.every((value, i) => value === values[i]));
    return native ? entries[String(native.id)] : undefined;
  }
  if (typeof module !== 'undefined') module.exports = { labelFor, entryFor, cardEntryFor, displayDimension };
  if (typeof customElements === 'undefined' || customElements.get('zd-tabletop-base')) return;
  customElements.define('zd-tabletop-base', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('script').textContent);
      this.isCard = this.dataset.context === 'card';
      this.scope = this.isCard ? this.closest('.card-wrapper') : this.closest('section');
      this.onChange = () => this.update();
      this.onDismiss = event => {
        if (event.key === 'Escape' || (event.type === 'click' && !this.contains(event.target))) {
          this.querySelector('details').open = false;
        }
      };
      this.scope?.addEventListener('change', this.onChange);
      document.addEventListener('click', this.onDismiss);
      this.addEventListener('keydown', this.onDismiss);
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onDismiss);
      this.removeEventListener('keydown', this.onDismiss);
    }
    update() {
      if (this.isCard) {
        const input = this.scope?.querySelector('zd-mvp-card-options input:checked');
        this.show(cardEntryFor(this.data.variants, input?.dataset.variantId || this.dataset.variantId));
        return;
      }
      const picker = this.scope?.querySelector('variant-radios, variant-selects');
      if (!picker) return;
      const values = picker.matches('variant-radios')
        ? Array.from(picker.querySelectorAll('fieldset')).map(f => f.querySelector('input:checked')?.value)
        : Array.from(picker.querySelectorAll('select')).map(s => s.value);
      // Picker JSON contains localized option labels; native IDs remain stable.
      const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      const entry = entryFor(this.data.variants, variants, values);
      this.show(entry);
    }
    show(entry) {
      const label = this.querySelector('[data-base-label]');
      label.textContent = labelFor(entry, this.data.labels, this.dataset.locale, this.isCard);
      this.hidden = !label.textContent;
      if (this.hidden) this.querySelector('details').open = false;
    }
  });
})();
